export type ExportStatusClass = 'open' | 'klaar' | 'mislukt';

const OPEN: readonly string[] = ['waiting', 'inprogress'];

const KLAAR: readonly string[] = ['completed', 'already_exists_at_destination', 'alreadyexists'];

export function classifyExportStatus(status: string | null | undefined): ExportStatusClass {
    const value: string = (status ?? '').toLowerCase();

    if (OPEN.includes(value)) {
        return 'open';
    }

    if (KLAAR.includes(value)) {
        return 'klaar';
    }

    return 'mislukt';
}

export function isExportSettled(status: string | null | undefined): boolean {
    return classifyExportStatus(status) !== 'open';
}
